import { defineComponent as y, ref as C, computed as P, createBlock as a, openBlock as d, unref as s, withCtx as l, createVNode as f, createTextVNode as _ } from "vue";
import { ScalarIconBookBookmark as B } from "@scalar/icons";
import { NodeViewWrapper as L } from "@tiptap/vue-3";
import { useRouter as N } from "vue-router";
import h from "../../../EditorEmptyState.vue.js";
import w from "../../../EditorHandle.vue.js";
import { useExternalEditModal as A, NodeEditEvent as F } from "../../../events/index.js";
import { useEditorStore as M } from "../../../store.js";
import { useAttrModel as S } from "../../../../hooks/useAttrModel.js";
import { useIsEditable as V } from "../../../../hooks/useIsEditable.js";
import x from "./ScalarPageLink.vue.js";
const J = /* @__PURE__ */ y({
  __name: "CustomPageLink",
  props: {
    decorations: {},
    selected: { type: Boolean },
    updateAttributes: { type: Function },
    deleteNode: { type: Function },
    node: {},
    view: {},
    getPos: { type: Function },
    innerDecorations: {},
    editor: {},
    extension: {},
    HTMLAttributes: {}
  },
  setup(k) {
    const r = k, { isEditable: n } = V(r.editor), { state: E } = M(), u = S(r, "item"), m = C(null), { handleClick: v } = A(m, r, F.PageLink);
    function g() {
      n.value && v();
    }
    const t = P(
      () => {
        var e;
        return u.value ? (e = E.sidebarItems) == null ? void 0 : e[u.value.uid] : void 0;
      }
    ), i = N();
    function b() {
      var e, o, c, p;
      n.value || i.push({
        name: (e = t == null ? void 0 : t.value) == null ? void 0 : e.uid,
        params: {
          ...(c = (o = i == null ? void 0 : i.currentRoute) == null ? void 0 : o.value) == null ? void 0 : c.params,
          // If we are in editing mode we just pass the current page Uid to block navigation
          page: (p = t.value) == null ? void 0 : p.uid
        }
      });
    }
    return (e, o) => (d(), a(s(L), {
      ref_key: "el",
      ref: m,
      class: "guide-node-component",
      contenteditable: "false",
      onClick: g
    }, {
      default: l(() => [
        f(w, {
          editor: e.editor,
          getPos: e.getPos,
          node: e.node,
          shift: "0.4em"
        }, null, 8, ["editor", "getPos", "node"]),
        t.value ? (d(), a(x, {
          key: 0,
          isEditable: s(n),
          isEditor: !0,
          item: t.value,
          onClick: b
        }, null, 8, ["isEditable", "item"])) : (d(), a(h, {
          key: 1,
          editor: e.editor
        }, {
          icon: l(() => [
            f(s(B))
          ]),
          default: l(() => [
            o[0] || (o[0] = _(" Page Link "))
          ]),
          _: 1
        }, 8, ["editor"]))
      ]),
      _: 1
    }, 512));
  }
});
export {
  J as default
};
